module.exports = __webpack_public_path__ + "img/banner.55013df6.jpg";